import { useTranslations } from '@vocab/react';
import translations from './.vocab';
import {
  Box,
  Card,
  Column,
  Columns,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';
import React, { type FunctionComponent } from 'react';
import { defaultRoutes, useRoutes } from '../routes';
import { TextLinkComponent } from './TextLinkComponent';

interface SubscriptionProps {
  title: string;
  cardTitle: string;
  body: string | JSX.Element;
  body2?: string | JSX.Element;
  icon: string;
  link?: string;
  linkMessage?: string;
}

const Subscription: FunctionComponent<SubscriptionProps> = ({
  title,
  cardTitle,
  body,
  body2,
  icon,
  link,
  linkMessage,
}) => {
  const { t } = useTranslations(translations);
  const { preferenceCentrePath } = useRoutes();
  const internalRoutes: string[] = Object.values(defaultRoutes);
  const isInternalRoute = internalRoutes.includes(link || preferenceCentrePath);
  const textId = 'manage-link';
  const linkPath = link || preferenceCentrePath;
  const message = linkMessage || t('default-subscription-link-message');

  const body2Component = body2 ? <Text>{body2}</Text> : null;

  return (
    <Stack space="gutter">
      <Box
        data-testid="subscription-title"
        paddingTop="gutter"
        paddingLeft={['gutter', 'gutter', 'none']}
      >
        <Heading level="2" component="h1">
          {title}
        </Heading>
      </Box>
      <Card>
        <Columns space="gutter" alignY="center" collapseBelow="tablet">
          <Column width="content">
            <Box textAlign="center" paddingX="small">
              <img
                alt="subscription-icon"
                style={{
                  width: '88px',
                }}
                src={icon}
              />
            </Box>
          </Column>
          <Column width="3/4">
            <div data-testid="subscription-body">
              <Stack space="medium">
                <Heading level="3">{cardTitle}</Heading>
                <Text>{body}</Text>
                {body2Component}
                <Text>
                  <TextLinkComponent
                    isInternalRoute={isInternalRoute}
                    textId={textId}
                    linkPath={linkPath}
                    linkMessage={message}
                  />
                </Text>
              </Stack>
            </div>
          </Column>
        </Columns>
      </Card>
    </Stack>
  );
};

export default Subscription;
